<template>
  <div class="wrapper">
    <b-overlay :show="isLoading" rounded="sm" @shown="onShown">
      <b-breadcrumb>
        <b-breadcrumb-item>YOU ARE HERE</b-breadcrumb-item>
        <b-breadcrumb-item>
          <router-link tag="a" to="/app/applications">
            Applications</router-link
          >
        </b-breadcrumb-item>
        <b-breadcrumb-item>{{ formName }}</b-breadcrumb-item>
        <b-breadcrumb-item active>{{ modulName }}</b-breadcrumb-item>
      </b-breadcrumb>
      <b-container fluid>
        <b-card>
          <template v-slot:header>
            <b-row>
              <b-col sm="auto" md="9">
                <div class="text-left">
                  <h4>Category</h4>
                </div>
              </b-col>
              <b-col sm="auto" md="3">
                <div class="text-right">
                  <b-button
                    variant="success"
                    size="sm"
                    v-on:click="show = !show"
                    >Create</b-button
                  >
                </div>
              </b-col>
            </b-row>
          </template>
          <b-table
            responsive
            stickyColumn
            striped
            hover
            show-empty
            :per-page="paging.perPage"
            :current-page="paging.currentPage"
            :items="items"
            :fields="fields"
            head-variant="dark"
          >
            <template #cell(created_at)="{ item }">
              {{ new Date(item.created_at).toLocaleString("id-ID") }}
            </template>
            <template #cell(modified_at)="{ item }">
              <template v-if="item.modified_at">
                {{ new Date(item.modified_at).toLocaleString("id-ID") }}
              </template>
            </template>
            <template v-slot:cell(actions)="{ item }">
              <b-button
                style="margin-right: 5px"
                title="Delete"
                size="xs"
                variant="danger"
                v-on:click="deleteData(item.id)"
              >
                <b-icon icon="trash-fill" aria-label="Help"></b-icon>
              </b-button>
              <b-button
                title="Edit"
                size="xs"
                variant="warning"
                v-on:click="editData(item.id, item.name, item.pic_dept)"
              >
                <b-icon icon="pencil-square" aria-label="Help"></b-icon>
              </b-button>
            </template>
          </b-table>
          <div class="mt-3">
            Showing {{ pageItems }} of {{ items.length }} entries
            <b-pagination
              v-model="paging.currentPage"
              :total-rows="rows"
              :per-page="paging.perPage"
              align="right"
            >
            </b-pagination>
          </div>
        </b-card>
        <template>
          <!-- <b-modal
            v-model="show"
            @ok="onSubmit()"
            @hidden="cancel()"
            ok-title="Save"
            cancel-title="Cancel"
            ok-variant="success"
            cancel-variant="warning"
            header-bg-variant="secondary"
            footer-bg-variant="secondary"
            hide-backdrop
            size="lg"
            ref="modal"
            title="Form Category"
          > -->
          <b-modal
            v-model="show"
            ref="my-modal"
            header-bg-variant="secondary"
            footer-bg-variant="secondary"
            hide-backdrop
            size="lg"
            title="Form Category"
          >
            <div id="modal">
              <validation-observer ref="observer" v-slot="{ handleSubmit }">
                <b-form @submit.prevent="handleSubmit(onSubmit)">
                  <b-row>
                    <b-col cols="12">
                      <!-- Name -->
                      <validation-provider
                        name="Name"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group
                          label-cols="3"
                          label-cols-lg="3"
                          label-size="sm"
                        >
                          <template v-slot:label>
                            Category Name<code>*</code>
                          </template>
                          <b-form-input
                            id="inputName"
                            v-model="form.name"
                            :state="getValidationState(validationContext)"
                            trim
                          ></b-form-input>
                          <b-form-invalid-feedback id="inputName">{{
                            validationContext.errors[0]
                          }}</b-form-invalid-feedback>
                        </b-form-group>
                      </validation-provider>
                      <!-- /Name -->
                      <!-- Code -->
                      <validation-provider
                        name="Code"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group
                          label-cols="3"
                          label-cols-lg="3"
                          label-size="sm"
                        >
                          <template v-slot:label> Dept PIC </template>
                          <v-select
                            style="background: white"
                            label="department"
                            v-model="form.pic_dept"
                            :state="getValidationState(validationContext)"
                            :options="picOpt"
                            @input="changePIC"
                          >
                            <template #search="{ attributes, events }">
                              <input
                                class="vs__search"
                                :required="!form.pic_dept"
                                v-bind="attributes"
                                v-on="events"
                              />
                            </template>
                          </v-select>
                          <b-form-invalid-feedback id="inputPIC">{{
                            validationContext.errors[0]
                          }}</b-form-invalid-feedback>
                        </b-form-group>
                      </validation-provider>
                      <!-- /Code -->
                    </b-col>
                  </b-row>
                  <b-row class="float-right">
                    <b-button class="mr-3" type="submit" variant="success"
                      >Save</b-button
                    >
                    <b-button class="mr-3" variant="warning" @click="cancel()"
                      >Cancel</b-button
                    >
                  </b-row>
                </b-form>
              </validation-observer>
            </div>
            <template #modal-footer>
              <div class="h-300 bg-secondary"></div>
            </template>
          </b-modal>
        </template>
      </b-container>
      <template #overlay>
        <div ref="loadings" class="text-center">
          <b-icon
            icon="arrow-clockwise"
            font-scale="3"
            animation="spin"
          ></b-icon>
          <p id="cancel-label">Please wait...</p>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import { fnGET, fnPOST, fnPUT, fnDELETE } from "../../../../../api/api-methods";
import { APIPATH_DMS } from "../../../../../api/api-paths";
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      formName: "Category",
      modulName: "Dashboard",
      items: [],
      picOpt: [],
      fields: [
        { key: "actions", label: "#" },
        // {key:'code',label:'Code'},
        { key: "name", label: "Category" },
        "created_by",
        "created_at",
        { key: "modified_by", label: "Updated By" },
        { key: "modified_at", label: "Updated By" },
      ],
      paging: {
        perPage: 10,
        currentage: 1,
      },
      isLoading: false,
      form: {
        category_id: null,
        name: null,
        pic_dept_id: null,
        pic_dept: null,
        // code: null,
        created_by: null,
        modified_by: null,
        deleted_by: null,
      },
      show: false,
    };
  },
  computed: {
    ...mapGetters("session", ["userData"]),
    rows() {
      if (this.items) {
        return this.items.length;
      }
    },
    pageItems() {
      var totalPage = Math.ceil(this.rows / this.paging.perPage);
      if (this.paging.currentPage === totalPage) {
        return (
          (this.rows % this.paging.perPage) +
          this.paging.perPage * totalPage -
          this.paging.perPage
        );
      } else {
        return this.paging.perPage * this.paging.currentPage;
      }
    },
  },
  methods: {
    ...mapActions("session", ["showNotification"]),
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },

    changePIC() {
      this.form.pic_dept_id = this.form.pic_dept.id;
      this.form.pic_dept = this.form.pic_dept.department;
    },
    getDept() {
      fnGET(APIPATH_DMS.getDept)
        .then((rsp) => {
          Vue.set(this, "picOpt", rsp.data.payload);
        })
        .catch((err) => {
          return err;
        });
    },
    getCategory() {
      fnGET(APIPATH_DMS.getCategory)
        .then((rsp) => {
          Vue.set(this, "items", rsp.data.payload);
        })
        .catch((err) => {
          return err;
        });
    },
    FocusWarning() {
      if (this.form.name == null || this.form.name == "") {
        // alert("nama kosong");
        return false;
      }
      if (this.form.pic_dept == null || this.form.pic_dept == "") {
        // alert("pic dept kosong");
        return false;
      }
      this.onSubmit();
    },
    onSubmit() {
      if (this.form.name == null || this.form.name == "") {
        return false;
      }
      if (this.form.pic_dept == null || this.form.pic_dept == "") {
        return false;
      }
      Vue.set(this, "isLoading", true);
      if (this.form.category_id) {
        console.log(this.form);
        fnPUT(APIPATH_DMS.putCategory, this.form)
          .then((rsp) => {
            this.showNotification({
              type: "success",
              message: "Successfully Submitted",
            });
            Vue.set(this, "isLoading", false);
            this.getCategory();
            this.cancel();
          })
          .catch((err) => {
            this.showNotification({
              type: "danger",
              message: "Failed Submitted, Something wrong",
            });
            Vue.set(this, "isLoading", false);
            return err;
          });
        // this.cancel();
      } else {
        fnPOST(APIPATH_DMS.postCategory, this.form)
          .then((rsp) => {
            this.showNotification({
              type: "success",
              message: "Successfully Submitted",
            });
            Vue.set(this, "isLoading", false);
            this.getCategory();
            this.cancel();
          })
          .catch((err) => {
            this.showNotification({
              type: "danger",
              message: "Failed Submitted, Something wrong",
            });
            Vue.set(this, "isLoading", false);
            return err;
          });
        // this.cancel();
      }
    },
    editData(id, name, pic_dept) {
      Vue.set(this, "show", true);
      Vue.set(this.form, "category_id", id);
      Vue.set(this.form, "name", name);
      Vue.set(this.form, "pic_dept", pic_dept);
    },
    deleteData(id) {
      this.$bvModal
        .msgBoxConfirm("Are you sure?", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Delete",
          cancelTitle: "Cancel",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value === true) {
            Vue.set(this, "isLoading", true);
            fnPUT(APIPATH_DMS.deleteCategory, { category_id: id })
              .then((rsp) => {
                this.showNotification({
                  type: "success",
                  message: "Successfully Submitted",
                });
                Vue.set(this, "isLoading", false);
                this.getCategory();
              })
              .catch((err) => {
                this.showNotification({
                  type: "danger",
                  message: "Failed Submitted, Something wrong",
                });
                Vue.set(this, "isLoading", false);
                return err;
              });
          }
        });
    },
    setUserData() {
      Vue.set(this.form, "created_by", this.userData.fullname);
      Vue.set(this.form, "modified_by", this.userData.fullname);
      Vue.set(this.form, "deleted_by", this.userData.fullname);
    },
    onShown() {
      // Focus the cancel button when the overlay is showing
      this.$refs.loadings.focus();
    },
    cancel() {
      console.log("masuk");
      Vue.set(this.form, "category_id", null);
      Vue.set(this.form, "name", null);
      Vue.set(this.form, "pic_dept", null);
      this.$refs["my-modal"].hide();
    },
  },
  created() {
    this.getCategory();
    this.setUserData();
    this.getDept();
  },
};
</script>

<style></style>
